module.exports = __webpack_public_path__ + "Group 15723.22d36b4555c661adc63f.png";